'use strict';

/*
 *  options / dependancies / restrictions to consider:
 *   - this.scoresOnlyAfterDate = new Date(2016,09,01); //Oct 1st 2016
 *   - models.account.profile_completed_at
 *   - models.creditScore.last_batch_ran_at
 */

function MonthlyCreditScoreGraph() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.extends = [ChartLoader, CreditScoreColours];
  this.declaredClass = null;

  this.monthlyCreditScoreLineChart = null;

  this._lastBatchOfScoresRanAt = null; // will never be empty

  this.scoresOnlyAfterDate = new Date(2016, 9, 1); // Oct 1st 2016
  this._currentDate = new Date();
  this.monthsToPlot = []; // Date Objs
  this.monthsToPlotLabels = []; // eg ["Oct", "Nov", "Dec"];
  this.numberOfMonthsToPlot = 6;
  this.futureMonthsToShow = 1;
  this.lineTension = 0;
  this._currentMonth = this._currentDate.getMonth();
  this._currentYear = this._currentDate.getFullYear();
  this._currentMonthIndex = null;

  this.graphPlugins = {};
  this._dataPoints = [];
  this._optedOutDataPoints = []; // request for score not made because user opted out
  this._nullDataPoints = []; // request for score made but equifax returened no score value
  this._currentMonthSpecialDataPoints = [];
  this._dataPointStyles = [];
  this._dataPointStylesRadius = [];
  this._dataPointStylesWidth = [];
  this._dataPointStylesFill = [];
  this._dataPointStylesBorder = [];

  this.useGradientStroke = true;
  this.autoScaleRange = true;
  this.autoScaleBufferPercent = 0.4; // % space added to top and bottom
  this.hightlightCurrentMonth = true; // make x-axis label for current month white
  this.showYAxesTicks = false;
  this.xAxesMaxRotation = 0;

  this._dataStrokeStyle = null;

  this._upperRange = 990; // max+90
  this._lowerRange = 210; // min-90

  this._validInRangeScores = [];
  this._validInRangeColorStopsByScores = [];
  this._highestScore = null;
  this._lowestScore = null;
  this._totalRangePTS = null; // highest score - lowest score
  this._bufferPTS = null;
  this._nullPlotValue = null;

  this._colors = {
    white: '#fff',
    gondola: '#363636',
    emperor: '#4f4f4f'
  };

  this.isValidDataToChart = true;

  this._debugMode = false;

  this.init = function () {
    this._submitConsentCallback = this.presenter.addCallbackToAction('account.edit_monthly_credit_check_opt_in', $.proxy(this._onSubmitConsent, this));
  };

  this._onSubmitConsent = function (data, response) {
    if (response == 200) {
      // need to update data and refresh the chart to show the special tooltip for the current month
      // [#138653643] only change data if you don't have a credit score for the current month already
      if (this._optedOutDataPoints[this._currentMonthIndex] != null) {
        this._optedOutDataPoints[this._currentMonthIndex] = null;
        this._currentMonthSpecialDataPoints[this._currentMonthIndex] = this._nullPlotValue;
      }
      this.monthlyCreditScoreLineChart.update();
    }
  };

  this.preInitChartJS = function () {
    this._super();

    // Debugging and testing options
    this._configDevOptions();

    this._sanitizeScores();

    if (this.sanitizedScores.length === 0) {
      this.isValidDataToChart = false;
      return;
    }

    // Establish start and stop points of Months (X-Axis)
    this._configurePlottingOptions();
  };

  this.initAllReady = function () {
    this._super();
    // NOTE: MonthlyCreditScoreGraph component is called by CreditScoreDashboard.js after creditScore Model is done loading.
  };

  this._configDevOptions = function () {
    if (getURLParameter('debugMode').trim() == 'true') {
      this._debugMode = true;
    }
    if (getURLParameter('useGradientStroke').trim() == 'true') {
      this.useGradientStroke = true; // TODO: what about false duh.
    }
    if (getURLParameter('autoScaleRange').trim() == 'true') {
      this.autoScaleRange = true;
    }
    var numberOfMonthsToPlot = getURLParameter('numberOfMonthsToPlot').trim();
    if (numberOfMonthsToPlot) {
      this.numberOfMonthsToPlot = numberOfMonthsToPlot;
    }

    var scoresOnlyAfterDate = getURLParameter('scoresOnlyAfterDate').trim();
    if (scoresOnlyAfterDate == 'Oct2015') {
      this.scoresOnlyAfterDate = new Date(2015, 9, 1); // Oct 1st 2015
    }

    // console.info("%s Options: [debugMode:%s, autoScaleRange:%s, useGradientStroke:%s, numberOfMonthsToPlot:%s]",
    //   this.id,
    //   this._debugMode,
    //   this.autoScaleRange,
    //   this.useGradientStroke,
    //   this.numberOfMonthsToPlot);
  };

  this._sanitizeScores = function () {
    var _this = this;
    _this.sanitizedScores = this.presenter.models.creditScore.credit_scores;

    // example months to plot (6): [d11, d22, d33, d44, d55, d66]
    // example scores returned by API: [d66, d44, d33, d22, d14, d13m d4, d1]
    // example cleaned data: [NULL, d22, d33, d44, NULL, d66]

    // Sort and Parse availableScores so it only goes back X months.
    _this.sanitizedScores = _this.sanitizedScores.filter(function (d) {
      var scoreDate = new Date(d.created_at);
      return scoreDate >= _this.scoresOnlyAfterDate;
    });
    _this.sanitizedScores.reverse();

    //  if (this._debugMode) console.log("_this.sanitizedScores FILTERED (%o)", _this.sanitizedScores);
  };

  this._configurePlottingOptions = function () {
    var _this = this;
    var today = new Date(); // First Month
    var firstMonthDate = new Date(); // First Month

    var firstScoreDate = new Date(_this.sanitizedScores[0].created_at);
    var firstScoreMonth = firstScoreDate.getMonth();
    var firstScoreYear = firstScoreDate.getFullYear();
    var monthsSinceFirstScore = this.monthsAgo(firstScoreDate, today);

    if (this.numberOfMonthsToPlot === 'all') {
      $('.box-layout').addClass('box-layout--wide-view');
      this.numberOfMonthsToPlot = monthsSinceFirstScore;
      if (this.numberOfMonthsToPlot < 6) this.numberOfMonthsToPlot = 6; // Force min again.
    }
    if (this.numberOfMonthsToPlot > 6) {
      if (this.numberOfMonthsToPlot > 20) this.numberOfMonthsToPlot = 20; // Cap it.
      this.xAxesMaxRotation = 90; // let things sqeeze as needed
      this.hightlightCurrentMonth = false; // conflicts with rotation
      this.showYAxesTicks = true; // unrelated but perhaps nice
    }

    // Plot from left to right starting with users first score...
    // If user has less than 5 months since they received their first score
    // plot the first score on the far left (1st position) and display 5 months to the right
    if (monthsSinceFirstScore < this.numberOfMonthsToPlot) {
      if (this._debugMode) console.info(' ~~~ PLOT FROM LEFT all scores and the empty future ~~~ ');
      for (var mnth = 0; mnth < this.numberOfMonthsToPlot; mnth++) {
        var hdt = new Date();
        hdt.setFullYear(firstScoreYear);
        hdt.setMonth(firstScoreMonth + mnth, 1);
        if (hdt >= _this.scoresOnlyAfterDate) {
          _this.monthsToPlot.push(hdt);
          _this.monthsToPlotLabels.push(moment(hdt).format('MMM'));
        }
      }
    } else {
      if (this._debugMode) console.info(' ~~~ PLOT FROM RIGHT recent and past scores ~~~ ');
      // Plot previous months in the Past
      // Plot the current month in the 5th position with 4 previous months to the left
      // and 1 future month to the right.

      // Past Months:
      for (var p = this.numberOfMonthsToPlot - this.futureMonthsToShow - 1; p >= 0; p--) {
        var pdt = new Date();
        pdt.setMonth(firstMonthDate.getMonth() - p, 1);
        if (pdt >= _this.scoresOnlyAfterDate) {
          _this.monthsToPlot.push(pdt);
          _this.monthsToPlotLabels.push(moment(pdt).format('MMM'));
        }
      }
      // Future Months:
      for (var f = 1; f <= this.futureMonthsToShow; f++) {
        var fdt = new Date();
        fdt.setMonth(firstMonthDate.getMonth() + f, 1);
        _this.monthsToPlot.push(fdt);
        _this.monthsToPlotLabels.push(moment(fdt).format('MMM'));
      }
    }

    for (var i = this.monthsToPlotLabels.length - 1; i >= 0; --i) {
      if (moment(this._currentDate).format('MMM') === this.monthsToPlotLabels[i]) {
        this._currentMonthIndex = i;
        break;
      }
    }
  };

  this.loadChart = function () {
    this._setupChartData();
    this._setupChartScale();
    this._setupPointStyles();
    this._setupPlugins();

    var ctx = this.node.getContext('2d');

    var lineChartData = {
      labels: this._generateChartLabels(),
      datasets: [{
        data: this._dataPoints,

        pointHitRadius: 14,

        pointStyle: this._dataPointStyles, // dash || circle
        pointBackgroundColor: this._dataPointStylesFill, // center of square || circle
        pointBorderColor: this._dataPointStylesBorder, // border of square || circle
        pointRadius: this._dataPointStylesRadius, //    12 || 6 // size
        pointBorderWidth: this._dataPointStylesWidth, //   4 || 4

        pointHoverBackgroundColor: this._colors.white,
        pointHoverBorderColor: this._dataPointStylesBorder,
        pointHoverRadius: this._dataPointStylesRadius,
        pointHoverBorderWidth: this._dataPointStylesWidth,

        spanGaps: false,
        fill: false,
        lineTension: this.lineTension,
        borderColor: this._dataStrokeStyle, // line color
        borderWidth: 2, // line width
        borderCapStyle: 'butt',
        borderJoinStyle: 'miter'
      },

      // Opted Out data points:
      {
        data: this._optedOutDataPoints,
        pointRadius: 0,
        fill: false,
        showLine: false
      },

      // NULL data points returned by equifax:
      {
        data: this._nullDataPoints,
        pointRadius: 0,
        fill: false,
        showLine: false
      },

      // Your next credit score update will come on the 1st of next month!
      {
        data: this._currentMonthSpecialDataPoints,
        pointRadius: 0,
        fill: false,
        showLine: false
      }]
    };

    var lineChartOptions = {
      defaultFontFamily: 'ProximaNova',
      defaultFontSize: 12,
      responsive: true,
      maintainAspectRatio: false,

      horizontalLine: [
      // add top line to chart area:
      {
        y: 'top',
        style: this._colors.emperor,
        width: 'topchartline'
      },
      // remove extra unwanted bit of xaxis on the right:
      {
        y: this._lowerRange,
        style: this._colors.gondola,
        width: 'rightmaskfix',
        strokeWidth: 4
      }],

      scales: {
        yAxes: [{
          gridLines: {
            display: false,
            color: this._colors.emperor,
            lineWidth: 2
          },
          ticks: {
            maxTicksLimit: 1, // to show only top and bottom ticks
            max: this._upperRange,
            min: this._lowerRange,
            // stepSize: (this._upperRange - this._lowerRange) / 2,
            display: this.showYAxesTicks,
            beginAtZero: 0 // make any diff?
          },
          scaleLabel: {
            display: true
          }
        }],
        xAxes: [{
          gridLines: {
            show: true,
            color: this._colors.emperor,
            lineWidth: 2,
            drawTicks: false
          },
          ticks: {
            fontColor: 'rgba(255,255,255,.5)',
            fontFamily: 'ProximaNova',
            fontSize: 14,
            padding: 10,
            maxRotation: this.xAxesMaxRotation, // (angle in degrees) 0 to stop x-axis labels from ever rotating in tight conditions
            minRotation: 0 // because the custom current month label doesnt rotate.
          },
          scaleLabel: {
            display: true,
            fontFamily: 'ProximaNova'
          }
        }]
      },

      gridLines: {
        display: true,
        color: this._colors.emperor,
        lineWidth: 20
      },

      legend: {
        display: false
      },

      tooltips: {
        mode: 'x-axis',
        caretSize: 7,
        titleFontSize: 14,
        titleFontFamily: 'ProximaNova',
        titleFontStyle: 'normal',
        bodyFontSize: 26,
        bodyFontFamily: 'ProximaNova',
        xPadding: 20,
        yPadding: 18,
        callbacks: {
          label: function label(tooltipItems, data) {
            // var value = data.datasets[0].data[tooltipItems.index];
            // var label = data.labels[tooltipItems.index];
            var labelTxt = tooltipItems.yLabel;
            if (tooltipItems.datasetIndex === 0) {
              return labelTxt;
            }
          },
          title: function title(tooltipItems, data) {
            var multistringText = [];
            if (tooltipItems[0].datasetIndex === 0) {} else if (tooltipItems[0].datasetIndex === 1) {
              multistringText.push('No credit score—you');
              multistringText.push('were opted out of');
              multistringText.push('getting one this month!');
              return multistringText;
            } else if (tooltipItems[0].datasetIndex === 2) {
              multistringText.push("Equifax couldn't find");
              multistringText.push('a score for you');
              multistringText.push('this month!');
              return multistringText;
            } else if (tooltipItems[0].datasetIndex === 3) {
              multistringText.push('Your next credit score');
              multistringText.push('update will come on the');
              multistringText.push('1st of next month!');
              return multistringText;
            }
          }
        },
        cornerRadius: 0
      }
    };

    Chart.defaults.global.elements.defaultFontFamily = 'ProximaNova';

    this.monthlyCreditScoreLineChart = new Chart(this.node, {
      type: 'line',
      data: lineChartData,
      options: lineChartOptions
    });
  };

  this._setupChartData = function () {
    var _this = this;
    var signupMonth = new Date(this.presenter.models.account.profile_completed_at);
    var userIsCurrentlyOptedIn = this.presenter.models.account.monthly_credit_check_opt_in;

    var availableScores = _this.sanitizedScores;
    _this._nullPlotValue = (_this._lowerRange + _this._upperRange) / 2; // (middle) tooltip for null and no score will be position based off of this value.

    this._lastBatchOfScoresRanAt = new Date(this.presenter.models.creditScore.last_batch_ran_at);
    // if (this._debugMode) console.log("_currentMonthIndex: (%s)", this._currentMonthIndex);
    // if (this._debugMode) console.log("_lastBatchOfScoresRanAt: (%s)", this._lastBatchOfScoresRanAt);
    // if (this._debugMode) console.log("signupMonth: (%s)", signupMonth);

    for (var m = 0; m < _this.monthsToPlot.length - this.futureMonthsToShow; m++) {
      _this._currentMonthSpecialDataPoints.push(null); // set default value

      var scoreRecordFound = false; // used to fill holes in data with null value
      var plotDate = new Date(_this.monthsToPlot[m]);
      var plotMonth = plotDate.getMonth();
      var plotYear = plotDate.getFullYear();
      // if (this._debugMode) console.log("plotMonth["+m+"]: (%s), plotYear:  (%s)", plotMonth, plotYear);

      for (var i = 0; i < availableScores.length; i++) {
        var availableScoreDate = new Date(availableScores[i].created_at);
        var availableScoreMonth = availableScoreDate.getMonth();
        var availableScoreYear = availableScoreDate.getFullYear();
        // if (this._debugMode) console.log("  - availableScoreMonth["+i+"]: (%s), availableScoreYear:  (%s)", availableScoreMonth, availableScoreYear);

        if (availableScoreMonth === plotMonth && availableScoreYear === plotYear) {
          // if (this._debugMode) console.log("[[[[x]]]] scoreRecordFound: (%s), (%s)", availableScoreMonth, availableScoreYear);
          scoreRecordFound = true;
          // found matching record but score value is NULL
          if (!availableScores[i].score) {
            _this._nullDataPoints.push(_this._nullPlotValue); // true 'no score' returned by equifax
            _this._dataPoints.push(null);
            _this._optedOutDataPoints.push(null);
          } else {
            _this._dataPoints.push(availableScores[i].score);
            _this._optedOutDataPoints.push(null);
            _this._nullDataPoints.push(null);
          }
        }
      }
      if (!scoreRecordFound) {
        var isCurrentMonth = m === _this._currentMonthIndex;
        var isCurrentOrFutureMonth = m >= _this._currentMonthIndex;
        // var currentMonthScoresProcessed = (this._lastBatchOfScoresRanAt >= this._firstOfCurrentMonth);
        this._firstOfTheMonth = new Date(_this.monthsToPlot[m].getFullYear(), _this.monthsToPlot[m].getMonth(), 1);
        var theMonthScoresProcessed = this._lastBatchOfScoresRanAt >= this._firstOfTheMonth;
        var isPreSignupMonth = signupMonth > _this.monthsToPlot[m];

        // if (this._debugMode) console.info("this._firstOfTheMonth:",this._firstOfTheMonth);
        // if (this._debugMode) console.info ("_this.monthsToPlot[m]", _this.monthsToPlot[m]);
        // if (this._debugMode) console.log ("..isCurrentOrFutureMonth? (%s)", isCurrentOrFutureMonth);
        // if (this._debugMode) console.log ("..theMonthScoresProcessed? (%s)", theMonthScoresProcessed);
        // if (this._debugMode) console.log ("..isPreSignupMonth? (%s)", isPreSignupMonth);
        // if (this._debugMode) console.log ("..isCurrentMonth? (%s)", isCurrentMonth);
        // if (this._debugMode) console.log ("..userIsCurrentlyOptedIn? (%s)", userIsCurrentlyOptedIn);

        if (isPreSignupMonth) {
          _this._optedOutDataPoints.push(null); // is month before user signed up
        } else if (isCurrentOrFutureMonth && !theMonthScoresProcessed) {
          _this._optedOutDataPoints.push(null); // we just hvnt batch processed scores for this month yet
        } else if (isCurrentMonth && userIsCurrentlyOptedIn) {
          _this._optedOutDataPoints.push(null); // user has opted in
          _this._currentMonthSpecialDataPoints[m] = _this._nullPlotValue;
        } else {
          _this._optedOutDataPoints.push(_this._nullPlotValue); // user was opted out
        }
        _this._dataPoints.push(null);
        _this._nullDataPoints.push(null);
      }
    }
    if (this._debugMode) console.info('Scores:', this._dataPoints);
    if (this._debugMode) console.info('Opted Out:', this._optedOutDataPoints);
    if (this._debugMode) console.info('NULL Returned:', this._nullDataPoints);
    if (this._debugMode) console.info('OptedInThisMnth:', this._currentMonthSpecialDataPoints);
  };

  this._setupChartScale = function () {
    if (this.autoScaleRange) {
      Array.max = function (array) {
        return Math.max.apply(Math, array);
      };
      Array.min = function (array) {
        return Math.min.apply(Math, array);
      };
      var data = this._dataPoints;
      // non-null scores:
      this._validInRangeScores = [];
      for (var x = 0; x < data.length; x++) {
        if (data[x]) {
          this._validInRangeScores.push(data[x]);
        }
      }
      if (Array.max(this._validInRangeScores) === Array.min(this._validInRangeScores)) {
        this._highestScore = this._upperRange; // save highest score before buffer added (default unscaled value)
        this._lowestScore = this._lowerRange; // save lowest score before buffer added (default unscaled value)
        this._totalRangePTS = this._upperRange - this._lowerRange;

        // reset/fix nulls and optouts positioning because the original range used has since been changed:
        this._nullPlotValue = (this._upperRange + this._lowerRange) / 2; // middle
      } else if (this._validInRangeScores.length > 1) {
        this._upperRange = Array.max(this._validInRangeScores);
        this._lowerRange = Array.min(this._validInRangeScores);
        this._highestScore = this._upperRange; // save highest score before buffer added
        this._lowestScore = this._lowerRange; // save lowest score before buffer added
        this._totalRangePTS = this._upperRange - this._lowerRange;
        this._bufferPTS = Math.ceil(this._totalRangePTS * this.autoScaleBufferPercent);
        // console.log("Auto Scale this._bufferPTS:",this._bufferPTS);
        this._upperRange += this._bufferPTS; // range used for graph Y-axis
        this._lowerRange -= this._bufferPTS; // range used for graph Y-axis
        this._upperRange = Math.round(this._upperRange);
        this._lowerRange = Math.round(this._lowerRange);

        // reset/fix nulls and optouts positioning because the original range used has since been changed:
        this._nullPlotValue = this._lowestScore - this._bufferPTS / 2; // middle of bottom buffer
      }

      // reset/fix nulls and optouts positioning because the original range used has since been changed:
      // TODO: refactor cause not cool to do things twice.
      // var _nullPlotValue = this._lowestScore - (this._bufferPTS / 2); // middle of bottom buffer
      // console.log(" _setupChartScale _nullPlotValue:",this._nullPlotValue);

      for (var i = 0; i < this._nullDataPoints.length; i++) {
        if (this._nullDataPoints[i] > 0) {
          this._nullDataPoints[i] = this._nullPlotValue;
        }
      }
      for (var j = 0; j < this._optedOutDataPoints.length; j++) {
        if (this._optedOutDataPoints[j] > 0) {
          this._optedOutDataPoints[j] = this._nullPlotValue;
        }
      }
      for (var k = 0; k < this._currentMonthSpecialDataPoints.length; k++) {
        if (this._currentMonthSpecialDataPoints[k] > 0) {
          this._currentMonthSpecialDataPoints[k] = this._nullPlotValue;
        }
      }
    }

    if (this._debugMode) console.info('Scores:', this._dataPoints);
    if (this._debugMode) console.info('Opted Out:', this._optedOutDataPoints);
    if (this._debugMode) console.info('NULL Returned:', this._nullDataPoints);
    if (this._debugMode) console.info('OptedInThisMnth:', this._currentMonthSpecialDataPoints);
  };

  this._setupPlugins = function () {
    var _this = this;
    var currentMonthIndex = this._currentMonthIndex;

    Chart.pluginService.clear();

    // gradient line:
    this.graphPlugins.fixGradientHeight = {
      afterScaleUpdate: function afterScaleUpdate(chartInstance, newChartSize) {
        _this._setupStrokeStyle(chartInstance); // need to recalulate the height (length) of the gradient each time
        chartInstance.config.data.datasets[0].borderColor = _this._dataStrokeStyle;
      }
    };
    Chart.pluginService.register(this.graphPlugins.fixGradientHeight);

    // draw current month label a different colour:
    this.graphPlugins.highlightCurrentMonth = {
      beforeDraw: function beforeDraw(chartInstance, newChartSize) {
        var chart = chartInstance.chart;
        var ctx = chartInstance.chart.ctx;

        var xaxis = chartInstance.scales['x-axis-0'];
        var yaxis = chartInstance.scales['y-axis-0'];

        // draw white current month in x-axis labels
        var text = xaxis.ticks[currentMonthIndex];
        ctx.save();
        ctx.fillStyle = 'rgba(255,255,255,1.0)';
        ctx.font = chart.config.options.scales.xAxes[0].ticks.fontSize + 'px ' + chart.config.options.scales.xAxes[0].ticks.fontFamily;
        ctx.textBaseline = 'top';
        ctx.textAlign = 'center';
        ctx.fillText(text, xaxis.getPixelForValue(undefined, currentMonthIndex), yaxis.bottom + chart.config.options.scales.xAxes[0].ticks.padding);
        ctx.restore();
      }
    };
    if (this.hightlightCurrentMonth) {
      Chart.pluginService.register(this.graphPlugins.highlightCurrentMonth);
    }

    // draw vertical dashed lines for opted out and null months:
    this.graphPlugins.optedOutAndNullGridlines = {
      afterDatasetsDraw: function afterDatasetsDraw(chartInstance, newChartSize) {
        // var chart = chartInstance.chart;
        var ctx = chartInstance.chart.ctx;

        var xaxis = chartInstance.scales['x-axis-0'];
        var yaxis = chartInstance.scales['y-axis-0'];

        var dottedLine = function dottedLine(c, x, y) {
          c.save();
          c.lineWidth = '2';
          c.setLineDash([3, 6]);
          c.beginPath();
          c.moveTo(x.getPixelForValue(undefined, index), y.top + 2);
          c.strokeStyle = _this._colors.gondola;
          c.lineTo(x.getPixelForValue(undefined, index), y.bottom - 2);
          c.stroke();
          c.restore();
        };

        // opted out
        var optedOuts = chartInstance.config.data.datasets[1].data;
        for (var index = 0; index < optedOuts.length; index++) {
          if (optedOuts[index] > 0) {
            dottedLine(ctx, xaxis, yaxis);
          }
        }

        // null value returned
        var nullValues = chartInstance.config.data.datasets[2].data;
        for (var index = 0; index < nullValues.length; index++) {
          if (nullValues[index] > 0) {
            dottedLine(ctx, xaxis, yaxis);
          }
        }

        // special current month msg
        var sValues = chartInstance.config.data.datasets[3].data;
        for (var index = 0; index < sValues.length; index++) {
          if (sValues[index] > 0) {
            dottedLine(ctx, xaxis, yaxis);
          }
        }
      }
    };
    Chart.pluginService.register(this.graphPlugins.optedOutAndNullGridlines);

    // draw general lines on the chart grid
    this.graphPlugins.horizonalLines = {
      beforeDatasetsDraw: function beforeDatasetsDraw(chartInstance) {
        var yScale = chartInstance.scales['y-axis-0'];
        var xScale = chartInstance.scales['x-axis-0'];
        var canvas = chartInstance.chart;
        var ctx = canvas.ctx;

        var index = void 0;
        var line = void 0;
        var style = void 0;
        var yValue = void 0;
        var xStartValue = void 0;
        var xEndValue = void 0;

        if (chartInstance.options.horizontalLine) {
          for (index = 0; index < chartInstance.options.horizontalLine.length; index++) {
            line = chartInstance.options.horizontalLine[index];

            if (!line.style) {
              style = 'rgba(169,169,169, .6)';
            } else {
              style = line.style;
            }

            // console.log(yScale.getPixelForValue(line.y));
            if (line.y && line.y === 'top') {
              yValue = 1;
            } else if (line.y) {
              yValue = yScale.getPixelForValue(line.y);
            } else {
              yValue = 0;
            }

            if (line.strokeWidth) {
              ctx.lineWidth = line.strokeWidth; // stroke size
            } else {
              ctx.lineWidth = 2; // stroke size
            }

            if (line.width && line.width === 'topchartline') {
              xStartValue = xScale.chart.chartArea.left;
              xEndValue = xScale.chart.chartArea.right - xScale.paddingRight;
            } else if (line.width && line.width === 'rightmaskfix') {
              xStartValue = xScale.chart.chartArea.right - xScale.paddingRight + 1;
              xEndValue = xScale.chart.chartArea.right;
            } else {
              xStartValue = 0;
              xEndValue = canvas.width;
            }

            if (yValue) {
              ctx.beginPath();
              ctx.moveTo(xStartValue, yValue);
              ctx.lineTo(xEndValue, yValue);
              ctx.strokeStyle = style;
              ctx.stroke();
            }
          }
        }
      }
    };
    Chart.pluginService.register(this.graphPlugins.horizonalLines);

    // custom plot points:
    // called from Chart.elements.Point
    // override lib function with our own custom points version
    Chart.canvasHelpers.drawPoint = function (ctx, pointStyle, radius, x, y) {
      var type = void 0;
      var edgeLength = void 0;
      var xOffset = void 0;
      var yOffset = void 0;
      var height = void 0;
      var size = void 0;

      if (isNaN(radius) || radius <= 0) {
        return;
      }

      switch (pointStyle) {
        // Default includes circle
        default:
          ctx.beginPath();
          ctx.arc(x, y, radius, 0, Math.PI * 2);
          ctx.closePath();
          ctx.fill();
          break;
        case 'mogocircle':
          // outer circle
          ctx.beginPath();
          ctx.arc(x, y, radius, 0, Math.PI * 2);
          ctx.fill();
          // inner dark mask around the white dot
          ctx.beginPath();
          ctx.fillStyle = ctx.strokeStyle;
          ctx.arc(x, y, radius / 1.4, 0, Math.PI * 2);
          ctx.fill();
          // inner white dot
          ctx.beginPath();
          ctx.fillStyle = '#ffffff';
          ctx.arc(x, y, radius / 2.6, 0, Math.PI * 2);
          ctx.fill();
          // grid line masks
          ctx.beginPath();
          ctx.arc(x, y, radius + ctx.lineWidth / 1.8, 1.4 * Math.PI, 1.6 * Math.PI);
          ctx.stroke();
          ctx.beginPath();
          ctx.arc(x, y, radius + ctx.lineWidth / 1.8, 2.4 * Math.PI, 2.6 * Math.PI);
          ctx.stroke();
          break;
        case 'mogorect':
          var width = 2;
          height = radius;
          ctx.beginPath();
          ctx.fillRect(x - width / 2, y - height / 2, width, height);
          // mask
          ctx.beginPath();
          ctx.moveTo(x - width, y - height / 2 - ctx.lineWidth / 2);
          ctx.lineTo(x + width, y - height / 2 - ctx.lineWidth / 2);
          ctx.moveTo(x - width, y + height / 2 + ctx.lineWidth / 2);
          ctx.lineTo(x + width, y + height / 2 + ctx.lineWidth / 2);
          break;
      }
      ctx.stroke();
    };
  };

  this._setupPointStyles = function () {
    var _this = this;
    for (var p = 0; p <= this.monthsToPlot.length; p++) {
      if (p === _this._currentMonthIndex) {
        _this._dataPointStyles.push('mogocircle');
        _this._dataPointStylesRadius.push(8); // radius of outer circle [8]
        _this._dataPointStylesWidth.push(10); // mask height (border aka ctx.lineWidth) [10]
        _this._dataPointStylesFill.push(_this.calculateScoreColor(_this._dataPoints[p]));
        _this._dataPointStylesBorder.push(_this._colors.gondola); // mask colour
      } else {
        _this._dataPointStyles.push('mogorect');
        _this._dataPointStylesRadius.push(10); // height  [10]
        _this._dataPointStylesWidth.push(8); // mask height (border aka ctx.lineWidth) [8]
        _this._dataPointStylesFill.push(_this.calculateScoreColor(_this._dataPoints[p]));
        _this._dataPointStylesBorder.push(_this._colors.gondola); // mask colour
      }
    }
  };

  this._setupStrokeStyle = function (c) {
    // console.log("this._totalRangePTS:",this._totalRangePTS);

    if (this._totalRangePTS === 0) {
      // single point range equals single colour line
      this._dataStrokeStyle = this.calculateScoreColor(this._validInRangeScores[0]);
    } else if (this.useGradientStroke && this._validInRangeScores.length > 1) {
      // create a new array of closest colors for active points in range
      // for each active score get closest color
      this._validInRangeColorStopsByScores = []; // reset for resize.
      for (var i = 0; i < this._validInRangeScores.length; i++) {
        var closestColour = this.calculateScoreColor(this._validInRangeScores[i]);
        this._validInRangeColorStopsByScores.push([this._validInRangeScores[i], closestColour]);
      }
      // console.log(this._validInRangeColorStopsByScores);

      // (x0,y0,x1,y1); y is top to bottom
      // convert buffer PTS to PXS
      var _chartAreaHeight = c.chartArea.bottom; // PX
      // var _bufferPixels = (_chartAreaHeight * (this.autoScaleBufferPercent*2))/2; //??? hmm div 2
      var _bufferPixels = _chartAreaHeight * this.autoScaleBufferPercent;

      var startGradient = _chartAreaHeight - _bufferPixels; // top (high score)
      var endGradient = 0 + _bufferPixels; // bottom (low score)

      var gradientstroke = c.chart.ctx.createLinearGradient(0, startGradient, 0, endGradient);
      // console.log("Adding %s color stops...",this._validInRangeColorStopsByScores.length);

      // TODO: this can go in for loop above now.
      for (var x = 0; x < this._validInRangeColorStopsByScores.length; x++) {
        var score = this._validInRangeColorStopsByScores[x][0];
        var percent = (score - this._lowestScore) / this._totalRangePTS;
        // console.log("...add %s(%s) stop color: %s",percent,score,this._validInRangeColorStopsByScores[x][1]);
        gradientstroke.addColorStop(percent, this._validInRangeColorStopsByScores[x][1]);
      }

      this._dataStrokeStyle = gradientstroke;
    } else {
      this._dataStrokeStyle = this._colors.white;
    }
  };

  this._generateChartLabels = function () {
    var LabelsArray = this.monthsToPlotLabels;
    return LabelsArray;
  };

  this._generateAccessibilityTable = function () {
    // TODO:
  };

  this.monthsAgo = function (d1, d2) {
    var months = void 0;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth() + 1;
    return months <= 0 ? 0 : months;
  };

  this.destroy = function () {
    this._super();

    // If loaded
    if (this.monthlyCreditScoreLineChart) {
      this.monthlyCreditScoreLineChart.destroy();
    }

    this.presenter.removeCallbackFromAction('account.edit_monthly_credit_check_opt_in', this._submitConsentCallback);
  };
}